import produce from 'immer';
import { equals } from 'ramda';

import {
    ADD_TRANSLATIONS,
    CLEAR_TRANSLATIONS,
    SHOW_TRANSLATION_KEYS,
    SET_DEFAULT_TRANSLATIONS
} from './actions';

export const defaultState = {
    translations: {},
    defaultTranslations: {},
    showTranslationKeys: false
};

export const reducer = produce((draftState, action) => {
    switch (action.type) {
        case ADD_TRANSLATIONS: {
            const translations = {
                ...draftState.translations,
                ...action.payload.translations
            };

            if (!equals(translations, draftState.translations)) {
                Object.assign(draftState, {
                    translations
                });
            }

            break;
        }

        case SET_DEFAULT_TRANSLATIONS: {
            const defaultTranslations = {
                ...draftState.defaultTranslations,
                ...action.payload.defaultTranslations
            };

            if (!equals(defaultTranslations, draftState.defaultTranslations)) {
                Object.assign(draftState, {
                    defaultTranslations
                });
            }

            break;
        }

        case CLEAR_TRANSLATIONS: {
            Object.assign(draftState, {
                translations: {}
            });

            break;
        }

        case SHOW_TRANSLATION_KEYS: {
            Object.assign(draftState, {
                showTranslationKeys: action.payload
            });

            break;
        }

        default:
            break;
    }
}, defaultState);
